module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-18-4a8c5f1f1b36ff17a103edce476b491d.jpg";